import { render, staticRenderFns } from "./BulkEditSettings.vue?vue&type=template&id=535407ce"
import script from "./BulkEditSettings.vue?vue&type=script&lang=ts"
export * from "./BulkEditSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports